const { ChakraProvider, theme } = require('@chakra-ui/react')
const React = require("react")
const { default: Navbar } = require('./src/components/navbar/Navbar')
// const Layout = require("./src/components/layouts/Layout")

// Logs when the client route changes
exports.onRouteUpdate = ({ location, prevLocation }) => {
    console.log("new pathname", location.pathname)
    console.log("old pathname", prevLocation ? prevLocation.pathname : null)
}

exports.wrapRootElement = ({ element }) => {
    return (
        <ChakraProvider theme={theme}>
            {element}
        </ChakraProvider>
    );
}